/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router-dom';
import { RemoveFile, UploadSecondary, Warn, GreenCheckMarkSvg } from '../../common/svg/AllSvg';
import { useTranslation } from 'react-i18next';

const SignatureFile = ({ submit, formik, setUpdSign, data, setDisSign, signErr, setSignErr, subFileErr, updSign, sign, setSign, signPro, setSignPro, type }: any) => {
    const [disable, setDisable] = useState<boolean>(false);
    const [selectFile, setSelectFile] = useState<any>("");
    const [err, setErr] = useState<any>("");
    const { t } = useTranslation('common');

    useEffect(() => {
        (!!data?.signature && !updSign) && setSign([{ name: `${data?.signature_details?.name}.${data?.signature_details?.type}`, url: data?.signature_details?.aws_file_url }]);
        (!!data?.signature && !updSign) && setSignPro(100);
    }, [data, updSign])

    useEffect(() => {
        if (sign?.length > 0) {
            setSignErr('')
        } else {
            setSignErr(t("recruitment.profile.err.sign"))
        }
    }, [sign])

    // common
    const simulateChunkUpload = (chunk: any) => {
        return new Promise((resolve: any, reject: any) => {
            setTimeout(() => {
                resolve();
            }, 1000);
        });
    };

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop: (acceptedFiles: any) => {
            setErr("")
            if (!acceptedFiles[0]?.name?.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
                setErr(t("passenger.lost_found.report_form.validation.valid_file"));
                return true;
            }

            if (acceptedFiles[0].size > (5 * 1000 * 1024)) {
                setErr(t("passenger.lost_found.report_form.validation.size_err"));
                return;
            }

            let re: any = /(?:\.([^.]+))?$/
            let ext: any = re.exec(acceptedFiles[0]?.name)[1];
            setSignPro(0);
            setDisable(true)
            setDisSign(true)
            setSign([...sign, { file: acceptedFiles, url: URL.createObjectURL(acceptedFiles[0]), ext: ext, name: acceptedFiles[0]?.name }]);

            let uploadFile = acceptedFiles[0];
            if (uploadFile) {
                const chunkSize = 1024 * 1024; // 1MB chunk size
                const totalChunks = Math.ceil(uploadFile.size / chunkSize);
                let currentChunk = 0;

                const uploadNextChunk = () => {
                    const start = currentChunk * chunkSize;
                    const end = Math.min(start + chunkSize, uploadFile.size);
                    const chunk = uploadFile.slice(start, end);

                    simulateChunkUpload(chunk)
                        .then(() => {
                            currentChunk++;

                            if (currentChunk < totalChunks) {
                                const progress = Math.floor((currentChunk / totalChunks) * 100);
                                setSignPro(progress);

                                uploadNextChunk();
                            } else {
                                setSignErr('')
                                formik.setFieldValue("signature", uploadFile);
                                setUpdSign(true)
                                setSignPro(100);
                                setDisable(false)
                                setDisSign(false)
                            }
                        })
                        .catch((error) => {
                            console.error('Error uploading chunk', error);
                        });
                };

                uploadNextChunk();
            }
        }
    });

    const removeFile = (idx: number) => {
        let arr: any[] = [];
        for (let i = 0; i < sign.length; i++) {
            const el = sign[i];

            if (idx !== i) {
                arr.push(el)
            }
        }
        setSign(arr);
    };

    const thumbs = sign.map((file: any, idx: number) => (
        <div className="flex flex-col gap-[10px] w-[100px] relative" onMouseEnter={() => setSelectFile(idx)} onMouseLeave={() => setSelectFile("")} key={idx}>
            {(selectFile === idx && !!!type) && <button aria-label={t("aria_label.delete")} title={t("aria_label.delete")} type="button" className="min-w-[20px] min-h-[20px] rounded-[20px] bg-white dark:bg-bgDarkDull flex items-center justify-center absolute top-[-6px] right-[-6px] focus:shadow-[0_0_0_1px_#4E566D5e] hover:shadow-[0_0_0_1px_#4E566D5e] dark:focus:shadow-[0_0_0_1px_#ffffff5e] dark:hover:shadow-[0_0_0_1px_#ffffff5e]" onClick={() => removeFile(idx)}><RemoveFile className="fill-blackDull dark:fill-textBlackDull" /></button>}

            <Link to={file?.url} download={file?.url} target="_blank" className={`rounded-[6px] border bg-[#FFFAFA] dark:bg-[#2e3037] w-full  h-[100px] flex items-center justify-center ${(signPro !== 100 && (idx + 1 === sign?.length)) ? "border-primary focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border-secGreen focus:shadow-[0_0_0_2px_#36bd745e] hover:shadow-[0_0_0_2px_#36bd745e]"}`} onFocus={() => setSelectFile(idx)} onBlur={() => setSelectFile("")}>
                {(signPro !== 100 && (idx + 1 === sign?.length)) ?
                    <div className="w-[50px] h-[50px]">
                        <CircularProgressbarWithChildren value={signPro}
                            styles={buildStyles({
                                pathColor: "#059DB2",
                                trailColor: "#00000033",
                            })} strokeWidth={7}>
                            <p className="text-primary font-semibold">
                                {signPro}%
                            </p>
                        </CircularProgressbarWithChildren >
                    </div>
                    :
                    <>
                        <GreenCheckMarkSvg />
                    </>}
            </Link>
            {(signPro !== 100 && (idx + 1 === sign?.length)) ?
                <p className="text-primary text-xs font-medium">{t("passenger.lost_found.report_form.form.uploading")}...</p>
                :
                <h4 className="text-xs text-blackDark dark:text-textBlackDark font-medium break-word">{file?.name}</h4>}
        </div>
    ));

    return (
        <div className="flex flex-col gap-[15px] mt-[-10px] xsm:mt-[-15px] xlx:mt-[-20px]">
            <h6 className="text-blackDull dark:text-textBlackDull font-normal">PNG, JPG, JPEG   <span className="text-primaryText dark:text-white font-semibold"> | {t("passenger.lost_found.report_form.form.size")}</span></h6>

            <div className="flex gap-[15px] flex-wrap">
                {sign?.length > 0 && thumbs}

                <div>
                    <button type='button' className="w-fit h-fit focus:shadow-[0_0_0_2px_#0097d65e] rounded-[6px] hover:shadow-[0_0_0_2px_#0097d65e] disabled:opacity-[0.5] disabled:cursor-not-allowed disabled:!shadow-none hover:disabled:!shadow-none" disabled={disable || sign?.length === 1 || submit || !!type} {...getRootProps()} onClick={(e) => e.stopPropagation}>
                        <input {...getInputProps()} />
                        <div className="min-w-[100px] h-[100px] flex items-center justify-center flex-col gap-[10px] rounded-[6px] border-dashed border-2 border-secPurple bg-[#FFFAFA] dark:bg-[#2e3037] w-fit" onClick={open}>
                            <UploadSecondary />
                            <p className="text-xs text-secPurple font-semibold">{t("recruitment.home.upload")}</p>
                        </div>
                    </button>
                    {!!err && <div className="flex gap-[6px] mt-[4px]"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{err}</span>
                    </div>}
                    {(!!!err && subFileErr && !!signErr) && <div className="flex gap-[6px] mt-[4px]"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{signErr}</span>
                    </div>}
                </div>

            </div>
        </div>
    );
};

export default SignatureFile;